import type {
  CarAdditionalInfoValues,
  CarDocumentUploadValues,
  CarDriverFormValues,
  CarPaymentValues,
  CarPersonalFormValues,
  CarVehicleFormValues,
} from "@/D2C/features/car-quote/redux/type";
import type {
  HealthAdditionalInfoValues,
  HealthDetailsFormValues,
  HealthDocumentUploadValues,
  HealthHabitsFormValues,
  HealthPaymentValues,
  HealthPersonalFormValues,
  HealthQuickQuestionsFormValues,
} from "@/D2C/features/health-quote/redux/type";
import type { LifePlanDetailsFormValues } from "@/D2C/features/life-quote/redux/lifeQuoteSlice";
import type {
  TravelAdditionalInfoValues,
  TravelDetailsFormValues,
  TravelDocumentUploadValues,
  TravelPaymentValues,
  TravelPersonalFormValues,
} from "@/D2C/features/travel-quote/redux/type";
import type { StepFormHandle } from "@/shared/stepper/types";
import { useMemo, useRef } from "react";

export const useQuoteRefs = () => {
  const travelPersonalRef = useRef<StepFormHandle<TravelPersonalFormValues>>(null);
  const travelDetailsRef = useRef<StepFormHandle<TravelDetailsFormValues>>(null);
  const lifePersonalRef = useRef<StepFormHandle<TravelPersonalFormValues>>(null);
  const lifePlanDetailsRef = useRef<StepFormHandle<LifePlanDetailsFormValues>>(null);
  const travelDocumentUploadRef = useRef<StepFormHandle<TravelDocumentUploadValues>>(null);
  const travelAdditionalInfoRef = useRef<StepFormHandle<TravelAdditionalInfoValues>>(null);
  const travelPaymentRef = useRef<StepFormHandle<TravelPaymentValues>>(null);

  const carPersonalRef = useRef<StepFormHandle<CarPersonalFormValues>>(null);
  const carVehicleRef = useRef<StepFormHandle<CarVehicleFormValues>>(null);
  const carDriverRef = useRef<StepFormHandle<CarDriverFormValues>>(null);
  const carDocumentUploadRef = useRef<StepFormHandle<CarDocumentUploadValues>>(null);
  const carAdditionalInfoRef = useRef<StepFormHandle<CarAdditionalInfoValues>>(null);
  const carPaymentRef = useRef<StepFormHandle<CarPaymentValues>>(null);

  const healthPersonalRef = useRef<StepFormHandle<HealthPersonalFormValues>>(null);
  const healthDetailsRef = useRef<StepFormHandle<HealthDetailsFormValues>>(null);
  const healthHabitsRef = useRef<StepFormHandle<HealthHabitsFormValues>>(null);
  const healthQuickQuestionsRef = useRef<StepFormHandle<HealthQuickQuestionsFormValues>>(null);
  const healthDocumentUploadRef = useRef<StepFormHandle<HealthDocumentUploadValues>>(null);
  const healthAdditionalInfoRef = useRef<StepFormHandle<HealthAdditionalInfoValues>>(null);
  const healthPaymentRef = useRef<StepFormHandle<HealthPaymentValues>>(null);

  const postQuoteSectionRef = useRef<HTMLDivElement>(null);

  return useMemo(
    () => ({
      travelPersonalRef,
      travelDetailsRef,
      lifePersonalRef,
      lifePlanDetailsRef,
      travelDocumentUploadRef,
      travelAdditionalInfoRef,
      travelPaymentRef,
      carPersonalRef,
      carVehicleRef,
      carDriverRef,
      carDocumentUploadRef,
      carAdditionalInfoRef,
      carPaymentRef,
      healthPersonalRef,
      healthDetailsRef,
      healthHabitsRef,
      healthQuickQuestionsRef,
      healthDocumentUploadRef,
      healthAdditionalInfoRef,
      healthPaymentRef,
      postQuoteSectionRef,
    }),
    [
      travelPersonalRef,
      travelDetailsRef,
      lifePersonalRef,
      lifePlanDetailsRef,
      travelDocumentUploadRef,
      travelAdditionalInfoRef,
      travelPaymentRef,
      carPersonalRef,
      carVehicleRef,
      carDriverRef,
      carDocumentUploadRef,
      carAdditionalInfoRef,
      carPaymentRef,
      healthPersonalRef,
      healthDetailsRef,
      healthHabitsRef,
      healthQuickQuestionsRef,
      healthDocumentUploadRef,
      healthAdditionalInfoRef,
      healthPaymentRef,
      postQuoteSectionRef,
    ]
  );
};
